import type { TeamOfficeGetResponse } from "@bezoned/shared/types/api/team/team-office-get.types.js";

export function resolveCurrentTable(
  tableId: string | null,
  tables: TeamOfficeGetResponse["tables"]
): TeamOfficeGetResponse["tables"][number] | null {
  if (tableId === null) {
    return null;
  }

  return tables.find((table) => table.id === tableId) ?? null;
}
